import { wrapLazily } from "../lazy-loading/lazyWrapper";
export const routes = () => {
	return [
		{
			path: "/backoffice/storelistmanagement",
			component: wrapLazily(() => import("ci_bo_ui/StoreListManagementPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "empStoreListManagement",
			},
		},
		{
			path: "/backoffice/bannermanagement/campaigns",
			component: wrapLazily(() => import("ci_bo_ui/CampaignManagementPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "campaignManagement",
			},
			childRoutes: [
				{
					path: "/backoffice/bannermanagement/campaigns/:campaignId",
					component: wrapLazily(() => import("ci_bo_ui/CampaignManagementPage"), {
						usesBootstrap: true,
						usesMoment: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						noCustomerNeed: true,
						needsEmployee: true,
						trackingName: "campaignManagement",
					},
				},
			],
		},
		{
			path: "/backoffice/ab-experiments",
			component: wrapLazily(() => import("ci_bo_ui/ABExperimentsPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "abExperiments",
			},
			childRoutes: [
				{
					path: "/backoffice/ab-experiments/:experimentId",
					component: wrapLazily(() => import("ci_bo_ui/ABExperimentsPage"), {
						usesBootstrap: true,
						usesMoment: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						noCustomerNeed: true,
						needsEmployee: true,
						trackingName: "abExperiments",
					},
				},
			],
		},
		{
			path: "/backoffice/bannermanagement/creatives",
			component: wrapLazily(() => import("ci_bo_ui/CreativesManagementPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "creativesManagement",
			},
			childRoutes: [
				{
					path: "/backoffice/bannermanagement/creatives/:collectionId",
					component: wrapLazily(() => import("ci_bo_ui/CreativesManagementPage"), {
						usesBootstrap: true,
						usesMoment: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						noCustomerNeed: true,
						needsEmployee: true,
						trackingName: "creativesManagement",
					},
				},
			],
		},
	];
};
